import { getViteEnv } from './runtimeEnv';

/**
 * Configuration Service
 * Centralized service for managing application configuration
 * This helps avoid circular dependencies between ApiService and AuthService
 */
export class ConfigService {
	private static instance: ConfigService | null = null;
	private baseUrl: string = '';
	private authServerUrl: string = '';
	private clientId: string = '';

	private constructor() {}

	static getInstance(): ConfigService {
		if (!ConfigService.instance) {
			ConfigService.instance = new ConfigService();
		}
		return ConfigService.instance;
	}

	/**
	 * Initialize the configuration
	 */
	initialize(baseUrl: string, authServerUrl: string, clientId: string): void {
		this.baseUrl = baseUrl;
		this.authServerUrl = authServerUrl;
		this.clientId = clientId;
	}

	/**
	 * Get the API base URL
	 */
	getApiBaseUrl(): string {
		if (!this.baseUrl) {
			const envUrl = getViteEnv('VITE_API_URL') ?? process?.env?.VITE_API_URL;
			if (envUrl) {
				this.baseUrl = envUrl;
			}
		}
		return this.baseUrl;
	}

	/**
	 * Set the API base URL
	 */
	setApiBaseUrl(url: string): void {
		this.baseUrl = url;
	}

	/**
	 * Get the auth server URL
	 */
	getAuthServerUrl(): string {
		if (!this.authServerUrl) {
			const envUrl =
				getViteEnv('VITE_AUTH_SERVER_URL') ??
				process?.env?.VITE_AUTH_SERVER_URL;
			if (envUrl) {
				this.authServerUrl = envUrl;
			}
		}
		return this.authServerUrl;
	}

	/**
	 * Get the OAuth client ID
	 */
	getClientId(): string {
		if (!this.clientId) {
			const envClientId =
				getViteEnv('VITE_OAUTH_CLIENT_ID') ??
				process?.env?.VITE_OAUTH_CLIENT_ID;
			if (envClientId) {
				this.clientId = envClientId;
			}
		}
		return this.clientId;
	}
}

export default ConfigService;
